import _ from 'lodash';
import React from 'react';
import { Image } from 'console-kit';

const TILE_STYLES = {
  CHECKBOX:   'checkbox',
  CIRCLE:     'circle',
  BUTTON:     'button',
  CARD:       'card',
  FULL_BLEED: 'full-bleed',
  RADIO:      'radio',
};

TILE_STYLES.ALL = _.values(TILE_STYLES);

TILE_STYLES.CONFIGS = {
  [TILE_STYLES.CHECKBOX]: {
    text:  'Checkbox',
    value: TILE_STYLES.CHECKBOX,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/radio/checkbox-style-checkbox.svg'} />,
  },
  [TILE_STYLES.BUTTON]: {
    text:  'Button',
    value: TILE_STYLES.BUTTON,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/radio/radio-style-button.svg'} />,
  },
  [TILE_STYLES.CARD]: {
    text:  'Card',
    value: TILE_STYLES.CARD,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/radio/radio-style-card.svg'} />,
  },
  [TILE_STYLES.CIRCLE]: {
    text:  'Circle',
    value: TILE_STYLES.CIRCLE,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/radio/radio-style-circle.svg'} />,
  },
  // TODO Will be added shortly after the initial release so commenting out for now
  [TILE_STYLES.FULL_BLEED]: {
    text:  'Full-bleed',
    value: TILE_STYLES.FULL_BLEED,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/radio/radio-style-full-bleed.svg'} />,
  },
  [TILE_STYLES.RADIO]: {
    text:  'Radio button',
    value: TILE_STYLES.RADIO,
    image: <Image src={App.globalContext.assetURL + 'c/img/screen-designer/radio/radio.svg'} />,
  },
};

TILE_STYLES.RADIO_LIST = [
  TILE_STYLES.CONFIGS[TILE_STYLES.RADIO],
  TILE_STYLES.CONFIGS[TILE_STYLES.BUTTON],
  TILE_STYLES.CONFIGS[TILE_STYLES.CARD],
  TILE_STYLES.CONFIGS[TILE_STYLES.CIRCLE],
];

TILE_STYLES.CHECKBOX_LIST = [
  TILE_STYLES.CONFIGS[TILE_STYLES.CHECKBOX],
  TILE_STYLES.CONFIGS[TILE_STYLES.BUTTON],
  TILE_STYLES.CONFIGS[TILE_STYLES.CARD],
  TILE_STYLES.CONFIGS[TILE_STYLES.CIRCLE],
];

TILE_STYLES.SWIPE_LIST = [TILE_STYLES.CONFIGS[TILE_STYLES.BUTTON], TILE_STYLES.CONFIGS[TILE_STYLES.CIRCLE]];

export default TILE_STYLES;
